var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_OVERLAY_DATA } from "../actions/overlayAction";
var initialState = {
    overlayData: { image: '', isVisible: false }
};
export function getOverlayData(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_OVERLAY_DATA:
            return __assign(__assign({}, state), { overlayData: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=overlayReducer.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_OVERLAY_DATA } from "../actions/overlayAction";
var initialState = {
    overlayData: { image: '', isVisible: false }
};
export function getOverlayData(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_OVERLAY_DATA:
            return __assign(__assign({}, state), { overlayData: action.payload });
        default:
            return state;
    }
}
//# sourceMappingURL=overlayReducer.js.map